/* PunchTempo landing behaviour. No dependencies. */

/* Shopify cart permalinks: variant ID x quantity. Pack 2 applies the PACK2 discount code. */
const PLANS = {
  single: {
    url: "/cart/59011523182927:1",
    name: "1 PunchTempo",
    price: "54,99 €",
    save: "Ahorras 25,00 € <span>(−31 %)</span>",
    label: "Comprar 1 · 54,99 €",
  },
  pack: {
    url: "/cart/59011523182927:2?discount=PACK2",
    name: "Pack 2 PunchTempo",
    price: "89,99 €",
    save: "Ahorras 69,99 € <span>(−43 %)</span>",
    label: "Comprar Pack 2 · 89,99 €",
  },
};

document.documentElement.classList.add("js");
/* Reveal with opacity only: fully clipped elements are never treated as visible by Chrome, so lazy images would not load. */
document.querySelectorAll('[data-reveal="clip"]').forEach((el) => el.setAttribute("data-reveal", ""));

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ---------- plan selection, shared by every picker on the page ---------- */
let plan = "single";
const radios = [...document.querySelectorAll('[data-picker] input[type="radio"]')];

function setPlan(next) {
  plan = next;
  const p = PLANS[plan];
  radios.forEach((r) => { r.checked = r.value === plan; });
  document.querySelectorAll("[data-buy]").forEach((a) => { a.href = p.url; });
  document.querySelectorAll("[data-save]").forEach((el) => { el.innerHTML = p.save; });
  document.querySelectorAll("[data-buy-label]").forEach((el) => { el.textContent = p.label; });
  const dockName = document.querySelector("[data-dock-name]");
  const dockPrice = document.querySelector("[data-dock-price]");
  if (dockName) dockName.textContent = p.name;
  if (dockPrice) dockPrice.textContent = p.price;
}
radios.forEach((r) => r.addEventListener("change", () => setPlan(r.value)));
document.querySelectorAll("[data-picker]").forEach((f) => f.addEventListener("submit", (e) => e.preventDefault()));
setPlan(plan);

/* ---------- offer countdown: real deadline from data-end; hides itself when it passes, never resets ---------- */
document.querySelectorAll("[data-countdown][data-end]").forEach((box) => {
  const end = new Date(box.dataset.end).getTime();
  const two = (n) => String(n).padStart(2, "0");
  const tick = () => {
    const left = end - Date.now();
    if (left <= 0) { box.hidden = true; return; }
    const s = Math.floor(left / 1000);
    box.querySelector("[data-d]").textContent = two(Math.floor(s / 86400));
    box.querySelector("[data-h]").textContent = two(Math.floor((s % 86400) / 3600));
    box.querySelector("[data-m]").textContent = two(Math.floor((s % 3600) / 60));
    box.querySelector("[data-s]").textContent = two(s % 60);
    window.setTimeout(tick, 1000 - (Date.now() % 1000));
  };
  tick();
});


/* ---------- rig: the machine photo cycles through its features while it is on screen ---------- */
const rig = document.querySelector("[data-rig]");
const steps = [...document.querySelectorAll(".act[data-step]")];
if (rig && steps.length && "IntersectionObserver" in window) {
  const tag = rig.querySelector("[data-rig-tag]");
  const count = rig.querySelector("[data-rig-count]");
  let step = 0;
  let hits = 0;
  let cycleTimer = 0;
  let countTimer = 0;
  const show = (i) => {
    step = i;
    rig.dataset.step = String(i);
    steps.forEach((a, k) => a.classList.toggle("is-active", k === i));
    tag.textContent = steps[i].dataset.tag;
    tag.parentElement.classList.remove("is-new");
    void tag.parentElement.offsetWidth; // restart the entry animation
    tag.parentElement.classList.add("is-new");
    window.clearInterval(countTimer);
    // one hit every 400 ms, in step with the pad sequence in CSS
    if (i === 3) countTimer = window.setInterval(() => { hits = (hits + 1) % 100; count.textContent = String(hits).padStart(2, "0"); }, 400);
  };
  const stopCycle = () => { window.clearInterval(cycleTimer); window.clearInterval(countTimer); };
  new IntersectionObserver(([e]) => {
    rig.classList.toggle("is-off", !e.isIntersecting);
    stopCycle();
    if (!e.isIntersecting || reduceMotion) return;
    show(step);
    cycleTimer = window.setInterval(() => show((step + 1) % steps.length), 3200);
  }, { threshold: 0.3 }).observe(rig);
}

/* ---------- drag comparison (punching bag vs PunchTempo): a range input drives the split ---------- */
document.querySelectorAll("[data-compare]").forEach((box) => {
  const frame = box.querySelector(".mp-vs__frame");
  const range = box.querySelector('input[type="range"]');
  const set = () => frame.style.setProperty("--pos", `${range.value}%`);
  range.addEventListener("input", set);
  set();
});

/* ---------- scroll reveals ---------- */
const revealables = document.querySelectorAll("[data-reveal]");
if (!reduceMotion && "IntersectionObserver" in window) {
  // stagger siblings inside the same list
  document.querySelectorAll(".lineup__list, .how__steps, .box__list").forEach((list) => {
    [...list.querySelectorAll("[data-reveal]")].forEach((el, i) => el.style.setProperty("--stagger", `${i * 60}ms`));
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
    });
  }, { rootMargin: "0px 0px -12% 0px", threshold: 0.15 });
  revealables.forEach((el) => io.observe(el));
  // safety net: never leave content hidden if the observer does not fire
  window.setTimeout(() => revealables.forEach((el) => el.classList.add("is-in")), 4000);
} else {
  revealables.forEach((el) => el.classList.add("is-in"));
}

/* ---------- mobile buy dock: visible between the hero picker and the offer section ---------- */
const dock = document.querySelector("[data-dock]");
const heroPick = document.querySelector(".hero .pick");
const offer = document.getElementById("oferta");
const closeSec = document.querySelector(".close");
if (dock && heroPick && "IntersectionObserver" in window) {
  const seen = new Map();
  const update = () => {
    const show = seen.get(heroPick) === false && !seen.get(offer) && !seen.get(closeSec) && seen.has(heroPick);
    dock.classList.toggle("is-shown", show);
    dock.setAttribute("aria-hidden", String(!show));
    dock.querySelector("a").tabIndex = show ? 0 : -1;
  };
  const dio = new IntersectionObserver((entries) => {
    entries.forEach((e) => seen.set(e.target, e.isIntersecting));
    update();
  });
  [heroPick, offer, closeSec].forEach((el) => el && dio.observe(el));
}

/* ---------- "Prueba el ritmo" demo ---------- */
const pads = [...document.querySelectorAll("[data-pad]")];
const padsWrap = document.querySelector("[data-pads]");
const toggle = document.querySelector("[data-demo-toggle]");
const bpmInput = document.querySelector("[data-bpm]");
const bpmOut = document.querySelector("[data-bpm-out]");
const soundBtn = document.querySelector("[data-sound]");
const hitsEl = document.querySelector("[data-hits]");
const streakEl = document.querySelector("[data-streak]");
const bestEl = document.querySelector("[data-best]");
const hubEl = document.querySelector("[data-hub]");

const state = { running: false, lit: -1, hitThisBeat: false, hits: 0, streak: 0, best: 0, timer: 0, sound: false };
let audio = null;

function bpm() { return Number(bpmInput.value); }

function click(accent) {
  if (!state.sound) return;
  audio = audio || new (window.AudioContext || window.webkitAudioContext)();
  const t = audio.currentTime;
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(accent ? 150 : 110, t);
  osc.frequency.exponentialRampToValueAtTime(45, t + 0.12);
  gain.gain.setValueAtTime(0.55, t);
  gain.gain.exponentialRampToValueAtTime(0.001, t + 0.16);
  osc.connect(gain).connect(audio.destination);
  osc.start(t);
  osc.stop(t + 0.17);
}

function render() {
  hitsEl.textContent = state.hits;
  streakEl.textContent = state.streak;
  bestEl.textContent = state.best;
  hubEl.textContent = String(state.hits % 100).padStart(2, "0");
}

function beat() {
  if (state.lit >= 0 && !state.hitThisBeat) state.streak = 0; // missed the last one
  pads.forEach((p) => p.classList.remove("is-lit"));
  let next;
  do { next = Math.floor(Math.random() * 4); } while (next === state.lit);
  state.lit = next;
  state.hitThisBeat = false;
  pads[next].classList.add("is-lit");
  click(true);
  render();
  state.timer = window.setTimeout(beat, 60000 / bpm());
}

function start() {
  state.running = true;
  padsWrap.classList.add("is-on");
  toggle.setAttribute("aria-pressed", "true");
  toggle.querySelector("span").textContent = "Pausa";
  toggle.querySelector("use").setAttribute("href", "#i-pause");
  beat();
}

function stop() {
  state.running = false;
  window.clearTimeout(state.timer);
  state.lit = -1;
  pads.forEach((p) => p.classList.remove("is-lit"));
  padsWrap.classList.remove("is-on");
  toggle.setAttribute("aria-pressed", "false");
  toggle.querySelector("span").textContent = "Empezar";
  toggle.querySelector("use").setAttribute("href", "#i-play");
}

function flash(pad, cls) {
  pad.classList.remove(cls);
  void pad.offsetWidth; // restart the class-driven transition
  pad.classList.add(cls);
  window.setTimeout(() => pad.classList.remove(cls), 140);
}

function hit(i) {
  const pad = pads[i];
  if (!state.running) { start(); return; }
  if (i === state.lit && !state.hitThisBeat) {
    state.hitThisBeat = true;
    state.hits += 1;
    state.streak += 1;
    state.best = Math.max(state.best, state.streak);
    pad.classList.remove("is-lit");
    flash(pad, "is-hit");
    click(false);
  } else {
    state.streak = 0;
    flash(pad, "is-miss");
  }
  render();
}

if (pads.length) {
  pads.forEach((p, i) => p.addEventListener("pointerdown", (e) => { e.preventDefault(); hit(i); }));
  // keyboard activation of a focused pad (Enter/Space) arrives as click with detail 0
  pads.forEach((p, i) => p.addEventListener("click", (e) => { if (e.detail === 0) hit(i); }));

  toggle.addEventListener("click", () => (state.running ? stop() : start()));
  bpmInput.addEventListener("input", () => { bpmOut.textContent = bpmInput.value; });
  soundBtn.addEventListener("click", () => {
    state.sound = !state.sound;
    soundBtn.setAttribute("aria-pressed", String(state.sound));
    soundBtn.querySelector("use").setAttribute("href", state.sound ? "#i-sound" : "#i-mute");
    if (state.sound && audio && audio.state === "suspended") audio.resume();
  });

  const keys = { d: 0, f: 1, j: 2, k: 3 };
  const demo = document.getElementById("prueba");
  let demoVisible = false;
  new IntersectionObserver(([e]) => {
    demoVisible = e.isIntersecting;
    if (!demoVisible && state.running) stop();
  }, { threshold: 0.2 }).observe(demo);
  window.addEventListener("keydown", (e) => {
    if (!demoVisible || e.metaKey || e.ctrlKey || e.altKey || e.repeat) return;
    if (e.target.closest("input, textarea")) return;
    const k = keys[e.key.toLowerCase()];
    if (k !== undefined) { e.preventDefault(); hit(k); }
  });
  document.addEventListener("visibilitychange", () => { if (document.hidden && state.running) stop(); });
}
